// externals
import { useSelector } from 'react-redux';
import type { FC } from 'react';

// components
import { BaseDealHeaderRoot, DealHeaderRightGroup } from './BaseDealActivity.interstate.style';
import { DeskingAlerts } from '../DeskingAlerts';
import {
    AioErrorAlert,
    ContractFailureAlert,
    PaymentStatus,
    CustomerSpdErrorAlert,
    GapRemovedForCashAlert,
    LenderAddressErrorAlert
} from '@makemydeal/dr-dash-components';
// selectors
import * as baseDealSelectors from '@makemydeal/dr-dash-store/selectors/BaseDealSelectors';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import BreakdownSlideout from './baseDealBreakdown/BreakdownSlideout';
import { BreakdownActionButton } from '../BreakdownActionButton/BreakdownActionButton';
import { useMediaQuery } from 'react-responsive';
import { BreakPoint } from '@makemydeal/dr-activities-common';

const BaseDealHeader: FC = () => {
    const isTabletScreenSize = useMediaQuery({ query: `(max-width: ${BreakPoint.MEDIUM})` });
    const enableGenerateContracts = useSelector(dealerSelectors.getEnableGenerateContracts);
    const isBaseDealExperience = useSelector(dealerSelectors.isBaseDealExperience);
    const showUpdateOfferForFSEvents = useSelector(baseDealSelectors.getShowUpdateOfferForFSEvents);
    const showLenderAddressAlert = useSelector(featureToggleSelectors.enableLenderAddress);

    const shouldShowBaseDealHeaderForCompactUI = isBaseDealExperience && isTabletScreenSize;

    return (
        <>
            <PaymentStatus sx={{ marginBottom: 2, marginTop: 2 }} />
            <DeskingAlerts sx={{ marginBottom: 2, marginTop: 2 }} />
            <CustomerSpdErrorAlert />
            {showLenderAddressAlert && <LenderAddressErrorAlert />}
            <GapRemovedForCashAlert />
            {enableGenerateContracts && <ContractFailureAlert />}
            {isBaseDealExperience && !showUpdateOfferForFSEvents && <AioErrorAlert />}
            <BreakdownSlideout />
            {shouldShowBaseDealHeaderForCompactUI && (
                <BaseDealHeaderRoot applyDealStatusStyles={true} data-testid="base-deal-header">
                    <DealHeaderRightGroup data-testid="base-deal-header-right-group">
                        <BreakdownActionButton />
                    </DealHeaderRightGroup>
                </BaseDealHeaderRoot>
            )}
        </>
    );
};

export default BaseDealHeader;
